import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import { EMPLOYEE_URLS } from "../../api/EmployeeUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import * as Yup from "yup";
import { USER_URLS } from "../../api/AdminUrls";

const validationSchema = Yup.object({
  new_pass: Yup.string().required("New Password is required"),

  confirm_pass: Yup.string().required("Confirm Password is required"),
});

interface Props {
  _id: any;
}

const UserPassChange: React.FC<Props> = ({ _id }) => {
  const { closeModal } = useSiteContext();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data: any) => {
    let url = USER_URLS.ADMIN_RESET;
    let payload = data;
    payload["id"] = _id;
    const subscription = post(url, payload).subscribe((response) => {
      closeModal();
    });
    return () => subscription.unsubscribe();
  };

  const elementstwo: SdsFormElementProps[] = [
    {
      type: "FILE",
      width: 6,
      name: "movie_image",
      element: {
        // label:"Upload Logo",
        placeHolder: "(Image)",
        accept: "*",
        // isHorizontal: true,
      },
    },

    {
      type: "BUTTON",
      width: 6,
      name: "submit",
      class_name: "has-text-right",
      element: { label: "Upload", onClick: handleSubmit(onSubmit) },
    },
  ];

  const elements: SdsFormElementProps[] = [
    {
      type: "PASSWORD",
      width: 12,
      name: "new_pass",
      element: {
        label: "New Password",
        inputType: "BORDER_LABEL",
        isRequired: true,
      },
    },
    {
      type: "PASSWORD",
      width: 12,
      name: "confirm_pass",
      element: {
        label: "Confirm Password",
        inputType: "BORDER_LABEL",
        isRequired: true,
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit",
      class_name: "has-text-right",
      element: { label: "Reset Password", onClick: handleSubmit(onSubmit),     classList: ["button", "smart-action-button"], },
    },
  ];

  return (
    <div className="mt-3 sd-hims-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default UserPassChange;
